// extracted by mini-css-extract-plugin
export default {"item":"WeddingAbcItem_item__NXv0z","letter":"WeddingAbcItem_letter__JXSxC","text":"WeddingAbcItem_text__C5C9Y"};